import debounce from 'lodash/debounce';
import React, {useState, useCallback} from 'react';
import { useAppDispatch } from '../../hooks/redux';

import {
    Autocomplete as AlchemyAutocomplete,
    AutocompleteProps
} from '@amzn/alchemy-components-react';

// Import from slice instead of actions
import { setUser } from '../../slices/userSlice';
import { SitesApiService } from '../../api/SitesApi';
import i18n from "../../i18n";

export default function() {
    const dispatch = useAppDispatch();
    const sitesApi = new SitesApiService()
    const [siteOptions, setSitesOptions] = useState<Array<{label: string, value: string}>>([{label: i18n.t('universal:loading'), value: "loading"}])

    const doSearch = (e: React.SyntheticEvent) => {
        const searchTerm = (e.target as any)._typedValue
        if (searchTerm.length >= 2 && 6 > searchTerm.length) {
            async function getSitesList() {
                const options: {label: string, value: string}[] = []
                const sitesList = await sitesApi.querySites(searchTerm)
                // Ensure sitesList is an array before mapping
                if (Array.isArray(sitesList)) {
                    sitesList.forEach((siteCode: string) => options.push({label: siteCode, value: siteCode}))
                }
                setSitesOptions(options)
            };
            getSitesList()
        }}

    const handleOnChange = (e: React.SyntheticEvent) => {
        const siteCode = (e.target as any).value;
        // prevent autocomplete assign null value while ESC key press down
        // https://code.amazon.com/packages/AlchemyComponents/blobs/5218171c001bc8b8405085389cb1d8c5616349b6/--/packages/alchemy/src/components/Autocomplete/Autocomplete.js#L188
        if (siteCode) {
            dispatch(setUser({whid: siteCode}));
        }
    }

    const handleInput = useCallback(debounce((e: React.SyntheticEvent) => doSearch(e), 1000), [])

    return (
        <AlchemyAutocomplete
            label=""
            search={false}
            placeholder={i18n.t('nav:change-site')}
            options={siteOptions}
            maxHeight="280px"
            trigger={2}
            onInput={handleInput}
            onChange={handleOnChange}
            noOptionsLabel={i18n.t('universal:no-options')}
        />
    )
}
